import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';

const SelectWithLabel = (props) => {
  const {
    textClass,
    classes: _classes,
    formControlClassName,
    ...otherProps
  } = props;

  const labelProps = {
    ...otherProps.focused,
    ...otherProps.error,
  };

  const controlProps = {
    ...labelProps,
    fullWidth: otherProps.fullWidth,
    className: formControlClassName,
  };

  return (
    <FormControl {...controlProps}>
      <FormLabel {...labelProps} className={textClass}>
        {otherProps.label}
      </FormLabel>
      <Select {...otherProps} />
    </FormControl>
  );
};

SelectWithLabel.defaultProps = {
  value: '',
};

SelectWithLabel.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  textClass: PropTypes.string,
};

export default SelectWithLabel;
